// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-contact-us-contact-form-submission-failed-stage----styles-module---container---NpYrs","buttons":"src-page-components-contact-us-contact-form-submission-failed-stage----styles-module---buttons---1Lcf3"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/contact-us/contact-form/submission-failed-stage/styles.module.css
// module id = 639
// module chunks = 43369700788870